import React from 'react';

import { FilterChipProps } from './index';
import { AppliedChip } from './AppliedChip';
import { LocationChip } from './LocationChip';

import { getTabIndex } from '../utils';

/**
 * NoResultsFilterChip only renders for applied filters.
 * The filters can only be removed, not edited.
 */
export const NoResultsFilterChip = ({
  activeChip,
  facet,
  updateSearch,
  index,
  log,
  onFocus,
  searchSummary
}: FilterChipProps) => {
  const selected = activeChip === index;
  const tabIndex = getTabIndex(activeChip, selected, index);

  const locationChip = facet.field === 'location';

  if (locationChip) {
    return (
      <LocationChip
        searchSummary={searchSummary}
        updateSearch={updateSearch}
        facet={facet}
        index={index}
        log={log}
        onFocus={onFocus}
        tabIndex={tabIndex}
      />
    );
  }
  return (
    <AppliedChip
      updateSearch={updateSearch}
      facet={facet}
      index={index}
      log={log}
      onFocus={onFocus}
      tabIndex={tabIndex}
    />
  );
};
